// src/routes/AdminRoutes.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import RoleBasedRoute from '../components/auth/RoleBasedRoute';
import DashboardLayout from '../components/layout/DashboardLayout';

// Admin Pages
import AdminLogin from '../pages/admin/AdminLogin';
import AdminDashboard from '../pages/admin/AdminDashboard';
import UserManagement from '../pages/admin/UserManagement';
import AdminManagement from '../pages/admin/AdminManagement';
import HospitalManagement from '../pages/admin/HospitalManagement';
import PharmacyManagement from '../pages/admin/PharmacyManagement';
import AmbulanceManagement from '../pages/admin/AmbulanceManagement';
import Analytics from '../pages/admin/Analytics';
import Reports from '../pages/admin/Reports';
import SystemSettings from '../pages/admin/SystemSettings';
import PaymentManagement from '../pages/admin/PaymentManagement';
import ContentManagement from '../pages/admin/ContentManagement';
import UserDetails from '../pages/admin/UserDetails';
import AdminForgotPassword from "../pages/admin/AdminForgotPassword";
import AdminProfile from '../pages/admin/AdminProfile';

const AdminRoutes = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<AdminLogin />} />
      <Route path="/forgot-password" element={<AdminForgotPassword />} />
      
      {/* Protected admin routes - allow both admin and superadmin */}
      <Route
        element={
          <ProtectedRoute>
            <RoleBasedRoute allowedRoles={['admin', 'superadmin']}>
              <DashboardLayout />
            </RoleBasedRoute>
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="users" element={<UserManagement />} />
        <Route path="users/:id" element={<UserDetails />} />
        <Route path="admins" element={<AdminManagement />} />
        <Route path="hospitals" element={<HospitalManagement />} />
        <Route path="pharmacies" element={<PharmacyManagement />} />
        <Route path="ambulances" element={<AmbulanceManagement />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="reports" element={<Reports />} />
        <Route path="payments" element={<PaymentManagement />} />
        <Route path="settings" element={<SystemSettings />} />
        <Route path="content" element={<ContentManagement />} />
        <Route path="profile" element={<AdminProfile />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;